import React from 'react';
import { motion } from 'framer-motion';
export function ValueSection() {
  return <section className="bg-cream py-20 px-4" data-id="element-311">
      <div className="max-w-4xl mx-auto" data-id="element-312">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-313">
          ¿Cuánto vale realmente esta información?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-soft overflow-hidden border border-soft-gray mb-10" data-id="element-314">
          <div className="overflow-x-auto" data-id="element-315">
            <table className="w-full text-left border-collapse" data-id="element-316">
              <thead data-id="element-317">
                <tr className="bg-navy text-white" data-id="element-318">
                  <th className="p-4 font-semibold text-lg" data-id="element-319">
                    Si buscaras esta ayuda por otro lado
                  </th>
                  <th className="p-4 font-semibold text-lg text-right" data-id="element-320">
                    Costo aproximado
                  </th>
                </tr>
              </thead>
              <tbody className="text-navy/80" data-id="element-321">
                <tr className="border-b border-soft-gray" data-id="element-322">
                  <td className="p-4" data-id="element-323">
                    Consulta con especialista en sueño infantil
                  </td>
                  <td className="p-4 text-right font-medium" data-id="element-324">
                    $60.000 a $150.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray" data-id="element-325">
                  <td className="p-4" data-id="element-326">
                    Asesoría de sueño personalizada (3 sesiones)
                  </td>
                  <td className="p-4 text-right font-medium" data-id="element-327">
                    $90.000 a $200.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray" data-id="element-328">
                  <td className="p-4" data-id="element-329">Libros importados especializados (x3)</td>
                  <td className="p-4 text-right font-medium" data-id="element-330">
                    $40.000 a $80.000
                  </td>
                </tr>
                <tr className="border-b border-soft-gray bg-red-50/50" data-id="element-331">
                  <td className="p-4" data-id="element-332">
                    Semanas de prueba y error sin información
                  </td>
                  <td className="p-4 text-right font-bold text-red-500" data-id="element-333">
                    Incalculable en agotamiento
                  </td>
                </tr>
                <tr className="bg-sky/10 font-bold text-navy text-lg" data-id="element-334">
                  <td className="p-4" data-id="element-335">Método Noches de Paz™ completo</td>
                  <td className="p-4 text-right" data-id="element-336">$19.990</td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-xl text-navy font-medium max-w-2xl mx-auto" data-id="element-337">
          Por menos de lo que cuesta una sola consulta, tenés acceso a un
          sistema completo que podés aplicar esta misma noche.
        </motion.p>
      </div>
    </section>;
}